module.exports = __webpack_public_path__ + "img/20230817_191838.6f7b6d5b.png";